import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "isDisabled", "value", "onChange", "description"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import useUniqueId from 'hooks/useUniqueId';
import CheckboxOption from 'components/CheckboxOption';
import { jsx as _jsx } from "react/jsx-runtime";
function ExcludeFromAIField(_ref) {
  var id = _ref.id,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    value = _ref.value,
    _onChange = _ref.onChange,
    description = _ref.description,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    as: "span",
    label: t('actions_exclude_from_ai'),
    labelId: uniqueId,
    description: description
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsx(CheckboxOption, {
      fontSize: "s",
      label: t('actions_exclude_content_from_ai_coach'),
      id: "exclude_from_ai",
      checked: value === 'mixed' ? false : value,
      indeterminate: value === 'mixed',
      disabled: isDisabled,
      onChange: function onChange(e) {
        return _onChange(e.target.checked);
      }
    })
  }));
}
export default ExcludeFromAIField;